export { default } from "ember-power-select/helpers/ember-power-select-is-array";
